// Point d'entrée principal de l'application React
// Configure les routes et le layout global de la page

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import About from "./components/About";
import Contact from "./components/Contact";
import Markdown from "./components/Markdown";
import CardReader from "./utils/CardReader";
import { LanguageProvider } from "./utils/LanguageContext";

const App = () => {
  return (
    <LanguageProvider>
      <Router>
        <div className="bg-slate-50 overflow-y-scroll h-screen flex flex-col">
        {/* Affiche le header */}
        <Header />
        {/* Définit les routes de l'application */}
        <Routes>
          <Route path="/" element={<CardReader />} />
          <Route path="/indicateurs" element={<CardReader />} />
          {/* <Route path="/indicateur" element={<Indicator />} /> */}
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/doc/:doc?" element={<Markdown />} />
          <Route path="/indicateur/:doc?" element={<Markdown />} />
        </Routes>
        {/* Affiche le footer */}
        <Footer />
        </div>
      </Router>
    </LanguageProvider>
  );
};

export default App;
